import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Observable } from "rxjs/internal/Observable";

@Injectable({
  providedIn: "root",
})
export class CommonService {
    private faqClickSubject = new Subject();
    private faqCloseSubject = new Subject();
    private faqOpenSubject = new Subject();


    expandFaqSection(header: string, subHeader: string) {
        this.faqClickSubject.next({faqHeader: header, faqSubHeader: subHeader});
    }

    getFaqSectionToExpand(): Observable<any>{
        return this.faqClickSubject.asObservable();
    }

    closeLightBox() {
        this.faqCloseSubject.next();
    }

    getCloseLightBox() {
        return this.faqCloseSubject.asObservable();
    }

    openLightBox() {
         this.faqOpenSubject.next();
    }

    getOpenLightBox() {
         return this.faqOpenSubject.asObservable();
    }

    faqCallback:Function;
    public closeFAQ() {
           this.faqCallback();
    }

    public setFAQClose(callback:Function) {
           this.faqCallback = callback;
    }

    bcImgCallback:Function;
    public closeBCImage() {
           if ( this.bcImgCallback )
                this.bcImgCallback();
    }

    public setBCImageClose(callback:Function) {
           this.bcImgCallback = callback;
    }

    clsoeAllFAQCallback:Function;
    public setCloseAllFAQ(callback:Function) {
           this.clsoeAllFAQCallback = callback;
    }

    public closeAllFAQ() {
           this.clsoeAllFAQCallback();
    }
}
